export default __webpack_public_path__ + "static/media/p3-14.9e27d6f3.png";